import { DAY, DECK_STATUS } from '../constants'

const DeckHelper = {
  methods: {
    getScoreAge (deck) {
      const lane = this.$store.getters.getLaneById(deck.lane)
      const growthRate = lane && lane.growthRate || DAY
      if (deck.status === DECK_STATUS.PENDING || growthRate <= 0) {
        return 0
      }
      const endTime = deck.archived
        ? deck.archivalDate.toDate()
        : Date.now()
      const age = endTime - deck.created.seconds * 1000
      return Math.floor(age / growthRate)
    },
    getScoreBumps (deck) {
      return deck.adjustment
      // return (deck.adjustments || [])
      //   .reduce((a, b) => a + (b.amount || 0), -deck.cost)
    },
    getScore (deck) {
      if (!deck) {
        return 0
      }
      const bumps = this.getScoreBumps(deck)
      const age = this.getScoreAge(deck)
      return deck.cost + bumps + age
    },
    getColorIcon (color) {
      switch (color) {
        case 'W': return 'fas fa-sun'
        case 'U': return 'fas fa-tint'
        case 'R': return 'fas fa-fire'
        case 'B': return 'fas fa-skull'
        case 'G': return 'fas fa-tree'
        case 'X': return 'fas fa-times'
      }
      return 'fas fa-question'
    },

    getStatus (deck) {
      if (deck.archived) {
        return DECK_STATUS.ARCHIVED
      }

      if (deck.active) {
        return DECK_STATUS.ACTIVE
      }

      if (deck.status === 'pending') {
        return DECK_STATUS.PENDING
      }

      return DECK_STATUS.APPROVED
    },
    getStatusIcon (deck) {
      switch (this.getStatus(deck)) {
        case DECK_STATUS.ARCHIVED: return 'fas fa-check'
        case DECK_STATUS.PENDING: return 'fas fa-clock'
        case DECK_STATUS.APPROVED: return 'fas fa-calendar'
      }
      return 'fas fa-question'
    },

    getRank (deck) {
      if (deck.archived) {
        return -1
      }
    }
  }
}

export default DeckHelper
